module.exports = __webpack_public_path__ + "static/solutions-module-decision-fr-20dd421da7f8ead9f248393f99801fb9.svg";